import React from 'react';
import InformationHeader from '../../../component/reusable/informationHeader/InformationHeader';
import AddVariantsForm from '../../../component/attributesComps/AddVariantsForm';

const AddVariants = () => {


  return (
    <div >
      <InformationHeader mainpage="Dashboard" prevpage="Categories"  pagename="Add Variants" buttonText="Save"/>
      <AddVariantsForm />
    </div>
  );
};

export default AddVariants;
